import React from 'react'
import Head from 'next/head'
import HeroSection from '../../containers/buy/hero-section'
import VehicleMarketplace from '../../containers/buy/vehicle-marketplace'
import FeaturesSection from '../../containers/buy/features-section'
import FAQ from '../../containers/buy/faq'
import Banner from '../../components/banner'
import ConciergeProcess from '../../containers/buy/concierge-process'
import RecentListingsSection from '../../containers/buy/recent-listings-section'

const BuyVehicle = () => {
  return (
    <div className='root'>
      <Head>
        <title>The Place To Buy And Sell Used Cars Near You | privauto</title>
        <meta
          name='description'
          content='privauto is the online car marketplace where you can find cars for sale near you or list your car for buyers. Sell your car to a buyer near you today.'
        />
      </Head>

      <section id='hero-section'>
        <HeroSection />
      </section>

      <section id='vehicle-marketplace' className='vehicle-marketplace'>
        <VehicleMarketplace />
      </section>

      <section id='feature-section' className='feature-section'>
        <FeaturesSection />
      </section>

      <section id='faq' className='faq-section'>
        <FAQ />
      </section>

      <section id='concierge-process' className='concierge-process'>
        <ConciergeProcess />
      </section>

      <section id='recent-listings' className='recent-listings'>
        <RecentListingsSection />
      </section>

      <section id='banner' className='banner'>
        <Banner />
      </section>

      <style jsx>{`
        .root {
          .vehicle-marketplace {
            margin-top: 5.6rem;
          }
          .feature-section {
            margin-top: 13.6rem;
          }
          .faq-section {
            margin-top: 13.8rem;
          }
          .concierge-process {
            margin-top: 12.2rem;
          }
        }

        @media (max-width: 1024px) {
          .root {
            .feature-section {
              margin-top: 7.5rem;
            }
            .faq-section {
              margin-top: 7.5rem;
            }
            .concierge-process {
              margin-top: 7rem;
            }
          }
        }
      `}</style>
    </div>
  )
}

BuyVehicle.getInitialProps = async () => ({
  namespacesRequired: ['common'],
})

export default BuyVehicle
